import React, { useState } from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleUp, faAngleDown} from "@fortawesome/free-solid-svg-icons";


const RevData = ({ data,replySave,cmptTypeUpdate,revInputs,revUserList }) => {
    const [comnShowing, setComnShowing] = useState(true);
    const toggleComnShwoing = () => {
        setComnShowing(prev => !prev);
    }
    
   
    const onClinkHandler = () => {
            // cmptTypeUpdate(data.cmptType,data.revNo);
    }
    const isCompleted = data.cmptType !== "R";
    return (
        <>
            <div>
                <div style={{color:isCompleted ? "#aaa": "", opacity: isCompleted ? 0.5 : 1}}>
                    <div style={{paddingBottom:10,borderTop:"1px solid #aaa"}} id="show1" >
                        <div style={{display:"flex",paddingTop:12}}>
                            <div style={{flex:"1"}}><label style={{fontWeight:"bold"}}>{data.userNm}</label> <small>{data.createDt}</small> <span onClick={toggleComnShwoing} style={{cursor:"pointer"}}>{comnShowing ? <FontAwesomeIcon icon={faAngleUp} /> : <FontAwesomeIcon icon={faAngleDown} />}</span></div>

                        </div>
                        <div style={{marginLeft:20,wordBreak: "break-word"}} dangerouslySetInnerHTML={ {__html: data.content}}></div>
                    </div>
                    <div style={{padding: "0 20px 0 20px"}}>
                    { comnShowing && data.comn.map((comnData, i) =>
                        <div key={`comData-${i}`}>
                            <div >
                                <div style={{paddingBottom:3}}>↳<label style={{fontWeight:"bold"}}>{comnData.userNm}</label> <small>{comnData.createDt}</small></div>
                                <div style={{marginLeft:20,wordBreak: "break-word"}} dangerouslySetInnerHTML={ {__html: comnData.revContent}}></div>
                            </div>
                        </div>
                    )}
                    </div>

                </div>
            </div>

        </>
    );

};

export default React.memo(RevData);
